// extracted by mini-css-extract-plugin
export default {"container":"Terms_container__AVip7"};